/**
 * Converts the given value into an array. If the input value is already an array, it is returned as-is.
 * Otherwise, the value is wrapped in a new array.
 *
 * @param value - The value to be converted to an array. It can be of any type.
 * @return Returns the input value as an array. If the input is already an array, it is returned unmodified; otherwise, the value is wrapped in an array.
 */
export function ensureArray<T, TArray = T extends any[] ? T : T[]>(value: T): TArray {
	if (Array.isArray(value)) return value as TArray;
	return [value] as TArray;
}
